export const PREFERENCES_ACTION = 'PREFERENCES_ACTION';
export const PREFERENCES_SUCCESS_ACTION = 'PREFERENCES_SUCCESS_ACTION';
export const PREFERENCES_FAILURE_ACTION = 'PREFERENCES_FAILURE_ACTION';
